<button *ngIf="count() > 0"
	type="button"
	class="btn btn-default presence-badge-btn"
	placement="bottom"
	container="body"
	[ngbTooltip]="tooltipTpl"
	tooltipClass="presence-tooltip"
	[attr.aria-label]="count() + ' weitere Sitzung(en) im Projekt'">
	<i class="bi bi-person-circle"></i>
	<span class="badge-count">{{ count() }}</span>
</button>

<ng-template #tooltipTpl>
	<div class="presence-tooltip-list">
		<div *ngFor="let p of others()" class="presence-tooltip-entry">
			<span class="presence-tooltip-name">{{ displayName(p) }}</span>
			<span class="presence-tooltip-meta">{{ sourceLabel(p.source) }} · {{ formatAge(p.ageSeconds) }}</span>
		</div>
	</div>
</ng-template>
